<template>

    <div class="order-process-component">

        <div class="content-with-sidebar-component">

            <div class="container">
                <div class="row">

                    <!-- Body -->
                    <div class="col-8 body">
                        <div>
                            <div class="order-form-component">

                                <div class="introduction">
                                    <div class="row">
                                        <div class="col-12">
                                            <h2>Company Car Scheme</h2>

                                            <h3 class="">Placing Your Order: Order Form</h3>

                                            <p>Just one step to go!</p>
                                            <p>Please review all details below and where necessary provide us with
                                                missing information. You will need to confirm and accept the
                                                declarations and key points as outlined below. The order cannot be
                                                submitted until they are accepted.</p>
                                            <p>After your order has been submitted JCT600 VLS will seek authorisation
                                                from your employer to place the order. You will receive an email
                                                confirmation when your order has been placed with the dealer.</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Employee Details -->
                                <driver-profile :profile="profile" :session="session"></driver-profile>

                                <key-policy></key-policy>

                                <!-- Vehicle Details -->
                                <div class="vehicle-details">

                                    <div class="row">
                                        <div class="col-12">
                                            <h4 class="text-uppercase">Vehicle Details</h4>
                                        </div>
                                    </div>

                                    <vehicle-card :derivative="derivative" :quote="quote"></vehicle-card>

                                    <!-- Checkbox -->
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="agree">
                                                <input type="checkbox" name="disclaimer" id="disclaimer_2"
                                                       class="disclaimer_2" v-model="confirmations.correctVehicle">
                                                <label for="disclaimer_2"><strong>[UNKNOWN]</strong> Disclaimer: Nullam
                                                    id dolor id nibh ultricies vehicula ut id elit.</label>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <!-- Delivery Details -->
                                <div class="delivery-details">

                                    <div class="row">
                                        <div class="col-12">
                                            <h4 class="text-uppercase">Delivery Details</h4>

                                            <p><strong>[UNKNOWN]</strong></p>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>


                    <!-- Sidebar -->
                    <div class="col-4 sidebar">
                        <cost-summary :type="'bch'" :order-detail="orderDetail" :confirmations="confirmations" :driver-profile="driverProfile" :adminPortalData="adminPortalData"></cost-summary>
                    </div>

                </div>
            </div>

        </div>

    </div>


</template>

<script>
    import {EventBus} from '@/event-bus.js';
    import DriverProfile from "./driver-profile";
    import CostSummary from "./ecoamaps/cost-summary.vue";
    import VehicleCard from "../vehicle-details/vehicle-card";
    import KeyPolicy from "./key-policy";

    export default {
        components: {KeyPolicy, VehicleCard, CostSummary, DriverProfile},
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.initSession();
                vm.get();
            })
        },

        props: [
            'adminPortalData',
            'adminPortalPrimaryProduct',
            'session',
            'submit-order'
        ],

        data: () => {
            return {
                tab: 'optional-extras',
                cashAllowance: null,
                contact: null,
                derivative: null,
                quote: null,
                driverGrade: null,
                driverProfile: null,
                orderDetail: null,
                orderType: 'BCH',
                employeeDetails: false,
                keyPolicyPoints: false,
                personalContractHireArrangement: false,

                profile: {
                    fullName: null,
                    forename: null,
                    surname: null,
                    emailAddress: null,
                    incomeTaxBand: null,
                    totalAnnualMileage: null,
                    businessAnnualMileage: null,
                    privateAnnualMileage: null,
                    companyCarGrade: null,
                    companyCarMileageReimbursementMethod: 'TODO - Advisory Fuel Rates',
                    privateCarGrade: null,
                    privateCarCashAllowance: 'TODO - £107',
                    privateCarMileageReimbursementMethod: 'TODO - AMAPS',
                    privateCarMileageReimbursementRateUpTo: 'TODO - 45 ppm',
                    privateCarMileageReimbursementRateOver: 'TODO - 16 ppm',
                },
                deliveryAddress: null,
                confirmations:{
                    employeeDetails: null,
                    correctVehicle: null,
                    keyPolicyPoints: null
                }
            }
        },

        methods: {
            get() {

                EventBus.$emit('loadingTitle', 'Beginning Company Car Order Process');
                EventBus.$emit('loading', true);

                this.$http.get('/api/salary-sacrifice-order-process')
                    .then(response => {

                        EventBus.$emit('loading', false);

                        this.$parent.session.order = response.data.data.results[0];
                        this.orderDetail = response.data.data.results[0];
                        let dp =  response.data.data.results[0].profile;
                        this.$parent.session.driverProfile = dp;
                        this.driverProfile = dp;

                        this.profile.fullName = dp.contacts[0].fullName;
                        this.profile.forename = dp.firstName;
                        this.profile.surname = dp.surname;
                        this.profile.emailAddress = dp.contacts[0].emailAddress;
                        this.profile.incomeTaxBand = dp.incomeTaxBand.ratePercent + '%';
                        this.profile.companyCarGrade = dp.driverGrades[0].name;
                        this.profile.privateCarGrade = dp.driverGrades[0].name;
                        this.profile.privateCarCashAllowance = dp.currentCashAllowances.totalMonthlyCurrentAllowance;
                        this.profile.totalAnnualMileage = Number(dp.annualBusinessDistance) + Number(dp.annualPrivateDistance);
                        this.profile.businessAnnualMileage = Number(dp.annualBusinessDistance);
                        this.profile.privateAnnualMileage = Number(dp.annualPrivateDistance);
                        this.profile.companyCarMileageReimbursementMethod = dp.homeElectricityReimbursementName_CompanyCar;
                        this.profile.privateCarMileageReimbursementMethod = dp.homeElectricityReimbursementName_PrivateCar;

                        this.derivative = response.data.data.results[0].derivative;
                        this.quote = response.data.data.results[0].quote;

                    })
                    .catch(err => {
                        EventBus.$emit('loading', false);
                        let response = err.response.data;

                        this.$notify({
                            group: 'notify',
                            type: 'error',
                            title: 'Error',
                            text: response.message
                        });
                        this.error = err.message.toString();

                        this.$router.push({name: response.redirect, params: {...this.$route.params}});
                    });
            },

            // tabs(tab) {
            //     this.tab = tab;
            // },

            submitVehicleOrder() {
                alert('Order Submitted!');
            },

            sanitizeTitle(title) {
                var slug = "";
                // Change to lower case
                var titleLower = title.toLowerCase();
                // Letter "e"
                slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
                // Letter "a"
                slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
                // Letter "o"
                slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
                // Letter "u"
                slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
                // Letter "d"
                slug = slug.replace(/đ/gi, 'd');
                // Trim the last whitespace
                slug = slug.replace(/\s*$/g, '');
                // Change whitespace to "-"
                slug = slug.replace(/\s+/g, '-');

                return slug;
            },

            initSession: function() {
                if (!this.$parent.session.orderDeliveryAddress){
                    this.$parent.session.orderDeliveryAddress = this.deliveryAddress;
                }
            }
        },

        computed: {
            canSubmitOrder() {
                return this.confirmations.employeeDetails && this.confirmations.keyPolicyPoints && this.confirmations.correctVehicle
            },

            privateCarMileageReimbursementRateUpTo(){
                if (this.$parent.session.driverProfile.businessFuelRates_PrivateCar) {
                    this.$parent.session.driverProfile.businessFuelRates_PrivateCar.items.forEach((item) => {
                        if (item.upToDistance === 10000) {
                            return item.fuelRate + ' ppm';
                        }
                    });
                }
                return 'Unknown';
            },
            privateCarMileageReimbursementRateOver(){
                let maxDistance = 0;
                let maxFuelRate = 'Unknown';

                if (this.$parent.session.driverProfile.businessFuelRates_PrivateCar) {
                    this.$parent.session.driverProfile.businessFuelRates_PrivateCar.items.forEach((item) => {
                        if (item.upToDistance > 10000 && item.upToDistance > maxDistance){
                            maxDistance = item.upToDistance;
                            maxFuelRate = item.fuelRate + ' ppm';
                        }
                    });
                }

                return maxFuelRate;
            }
        },

        watch: {
            session(value) {
                if (value.orders) {
                    if (value.orders.results[0]) {
                        this.derivative = value.orders.results[0].derivative;
                        this.orderDetail = value.orders.results[0];
                    }
                }

                if (value.order){
                    this.orderDetail = value.order;
                }

                if (value.driverProfile) {
                    this.driverProfile = value.driverProfile;
                    this.contact = value.driverProfile.contacts[0];
                    this.driverGrade = value.driverProfile[this.orderType];
                    this.cashAllowance = value.driverProfile.currentCashAllowances.totalAnnualCurrentAllowance;
                }
            },
            // deliveryAddress: {
            //     handler(value) {
            //         this.$parent.session.orderDeliveryAddress = value;
            //     },
            //     deep: true
            // },
            canSubmitOrder(value) {
                this.$emit('canSubmitOrder', value)
            },
            submitOrder: function (val) {
                if (val) {
                    this.submitVehicleOrder();
                }
            },
            confirmations:{
                handler(confirmations) {
                    for (const [ key, value ] of Object.entries(confirmations)) {
                        this.$parent.confirmations[key] = value;
                    }
                },
                deep: true
            },
        },
    }
</script>
